import React, { useEffect, useState } from 'react';
import { Badge, Button, Dropdown, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomAlert from '../../../components/CustomAlert';
import config from '../../../config/Constant';
import { postRequest, putRequest } from '../../../helpers/apiHandler';
import { truncateString } from '../../../helpers/helperFunction';
import CloseIcon from '../../SVG/CloseIcon';
import RedIconSVG from '../../SVG/RedIconSVG';
import CampaignDetails from './campaignDetails';
import SmsDetailModal from './SmsDetailModal';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const CampaignTables = ({
  data,
  loadingData,
  sendReloadData,
  setReloadData = () => { },
  dateRange,
}) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const [modalDetailShow, setModalDetailShow] = useState(false);
  const [campaignStatus, setCampaignStatus] = useState('');
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [campaignDetailsData, setCampaignDetailsData] = useState([]);
  const [smsDetailShow, setSmsDetailShow] = useState(false);
  const [campaignId, setCampaignId] = useState('');
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });


  const [isActive, setIsActive] = useState(false);
  const [activeRow, setActiveRow] = useState(null);


  const duplicateCampaign = campaignId => {
    const payload = { campaign_id: campaignId };
    postRequest('/v2/campaign/duplicate', payload, access_token.token, res => {
      if (res.success) {
        setAlertState({
          show: true,
          message: 'Campaign has been duplicated and saved as draft.',
          variant: 'success',
        });
        setReloadData(true);
      } else {
        setAlertState({
          show: true,
          message: 'Campaign has been stopped and is not running.',
          variant: 'danger',
        });
        setReloadData(false);
      }
    });
  };

  const deleteCampaign = (campaignId) => {
    const payload = { campaign_id: campaignId };

    postRequest('/v2/campaign-delete', payload, access_token.token, res => {
      if (res.success) {
        setAlertState({
          show: true,
          message: 'Campaign has been deleted successfully.',
          variant: 'success',
        });
        setCampaignDetailsData([]);
        setReloadData(true);
      } else {
        setAlertState({
          show: true,
          message: 'There was an error deleting the campaign. Please try again later.',
          variant: 'danger',
        });
        setReloadData(false);
      }
      setModalDeleteShow(false);
    });
  };

  const stopCampaign = (campaignId) => {
    const payload = { campaign_id: campaignId };
    putRequest('/v2/campaign/stop-campaign', payload, access_token.token, res => {
      if (res.success) {
        setAlertState({
          show: true,
          message: 'Campaign has been stopped and is not running.',
          variant: 'danger',
        });
        setReloadData(true);
      }
    })
  }

  const resumeCampaign = (campaignId) => {
    const payload = { campaign_id: campaignId };
    putRequest('/v2/campaign/resume-campaign', payload, access_token.token, res => {
      if (res.success) {
        setAlertState({
          show: true,
          message: `The ${data[0].name} campaign has been resumed and is now running live.`,
          variant: 'success',
        });
        setReloadData(true);
      }
    })
  }


  const handleModalDetailOpen = data => {
    const { status, campaignId, row } = data;

    setModalDetailShow(true);
    setCampaignStatus(status);
    setCampaignDetailsData(row);
  };

  const handleDeleteConfirmationOpen = rowData => {
    setModalDeleteShow(true);
    setCampaignDetailsData(rowData);
  };

  const handleDuplicate = campaignId => {
    duplicateCampaign(campaignId);
  };

  const handleEdit = (campaign_data) => {
    navigate("/dashboard/campaign/campaign-create", { state: { campaign_data } });
  };

  const draftTools = row => (
    <>
      <Dropdown.Item onClick={() => handleEdit(row)}>Edit</Dropdown.Item>
      <Dropdown.Item
        onClick={() => handleModalDetailOpen({ status: row.status, campaignId: row.id, row: row })}
      >
        View
      </Dropdown.Item>
      <Dropdown.Item onClick={() => handleDuplicate(row.id)}>Duplicate</Dropdown.Item>
      <Dropdown.Item onClick={() => handleDeleteConfirmationOpen(row)}>Delete</Dropdown.Item>
    </>
  );

  const completedTools = row => (
    <>
      <Dropdown.Item
        onClick={() => handleModalDetailOpen({ status: row.status, campaignId: row.id, row: row })}
      >
        View
      </Dropdown.Item>
      <Dropdown.Item onClick={() => handleDuplicate(row.id)}>Duplicate</Dropdown.Item>
    </>
  );

  const inProgressTools = row => (
    <>
      <Dropdown.Item onClick={() => handleModalDetailOpen({ status: row.status, campaignId: row.id, row: row })}>View</Dropdown.Item>
      <Dropdown.Item onClick={() => stopCampaign(row.id)}>Stop</Dropdown.Item>
    </>
  );

  const inCompleteTools = row => (
    <>
      <Dropdown.Item
        onClick={() => handleModalDetailOpen({ status: row.status, campaignId: row.id, row: row })}
      >
        View
      </Dropdown.Item>
      <Dropdown.Item onClick={() => handleDuplicate(row.id)}>Duplicate</Dropdown.Item>
      <Dropdown.Item onClick={() => resumeCampaign(row.id)}>Resume</Dropdown.Item>
    </>
  );

  const scheduledTools = row => (
    <>
      <Dropdown.Item
        onClick={() => handleModalDetailOpen({ status: row.status, campaignId: row.id, row: row })}
      >
        View
      </Dropdown.Item>
      <Dropdown.Item onClick={() => handleDuplicate(row.id)}>Duplicate</Dropdown.Item>
      <Dropdown.Item onClick={() => stopCampaign(row.id)}>Stop</Dropdown.Item>
      <Dropdown.Item onClick={() => handleDeleteConfirmationOpen(row)}>Delete</Dropdown.Item>
    </>
  );

  const failedTools = row => (
    <>
      <Dropdown.Item
        onClick={() => handleModalDetailOpen({ status: row.status, campaignId: row.id, row: row })}
      >
        View
      </Dropdown.Item>
      <Dropdown.Item onClick={() => handleDuplicate(row.id)}>Duplicate</Dropdown.Item>
    </>
  );

  const openSmsDetailModal = (id) => {
    setSmsDetailShow(true);
    setCampaignId(id);
  }

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  useEffect(() => {
    if (sendReloadData) {
      setTimeout(() => {
        setReloadData(false);
      }, config.notify_time);
    }
  }, [sendReloadData]);

  const columns = [
    {
      name: 'Status',
      sortable: true,
      center: 'true',
      width: '150px',
      selector: (row) => {
        let html = '';

        if (row.status === 'completed') {
          html = (
            <Badge style={{ color: '#1faf38', background: 'rgba(31,175,56,0.2)' }}>
              {row.status}
            </Badge>
          );
        }
        if (row.status === 'failed') {
          html = (
            <Badge style={{ color: '#de0d19', background: 'rgba(222,13,25,0.2)' }}>
              {row.status}
            </Badge>
          );
        }
        if (row.status === 'draft') {
          html = (
            <Badge style={{ color: '#b3b3b3', background: 'rgba(179,179,179,0.2)' }}>
              {row.status}
            </Badge>
          );
        }
        if (row.status === 'in_progress') {
          html = (
            <Badge style={{ color: '#1bf907', background: 'rgba(27,249,7,0.2)' }}>
              In-Progress
            </Badge>
          );
        }
        if (row.status === 'incomplete') {
          html = (
            <Badge style={{ color: '#f15a24', background: 'rgba(241,90,36,0.2)' }}>
              Incomplete
            </Badge>
          );
        }
        if (row.status === 'scheduled') {
          html = (
            <Badge style={{ color: '#ffa047', background: 'rgba(255,160,71,0.2)' }}>
              Scheduled
            </Badge>
          );
        }

        return html;
      },
    },
    {
      width: '150px',
      name: 'Campaign Name',
      sortable: true,
      selector: (row) => truncateString(row.name, 30),
    },
    {
      name: 'Campaign ID',
      sortable: true,
      selector: (row) => row.id,
    },
    {
      name: 'Type',
      sortable: true,
      selector: (row) => row.type,
    },
    {
      name: 'Mobile Number',
      sortable: true,
      selector: (row) => (
        <Link onClick={() => openSmsDetailModal(row.id)}>Details</Link>
      ),
    },
    {
      name: 'Created Time',
      sortable: true,
      selector: (row) => row.created_at,
    },
    {
      name: 'Scheduled Time',
      sortable: true,
      selector: (row) => row.starts_at,
    },
    {
      name: 'Total Message Sent',
      sortable: true,
      selector: (row) => new Intl.NumberFormat('en-US').format(row.total_sms_sent),
    },
    {
      name: 'Total Recipients',
      sortable: true,
      selector: (row) => new Intl.NumberFormat('en-US').format(row.total_recipients),
    },
    {
      name: 'Campaign Cost',
      sortable: true,
      selector: (row) => new Intl.NumberFormat('en-US').format(row.total_cost),
    },
    {
      name: 'Message Count',
      sortable: true,
      selector: (row) => new Intl.NumberFormat('en-US').format(row.sms_message_count),
    },
    {
      name: 'Actions',
      sortable: false,
      center: 'true',
      id: 'fixed-right',
      width: '100px',
      selector: (row) => (
        <Dropdown onToggle={(state) => handleToggleOpen(state, row)}>
          <Dropdown.Toggle variant="link" id="dropdown-table">
            <i className="fas fa-ellipsis-v" />
          </Dropdown.Toggle>
          <Dropdown.Menu align="right">
            {row.status === 'draft' && draftTools(row)}
            {row.status === 'scheduled' && scheduledTools(row)}
            {row.status === 'in_progress' && inProgressTools(row)}
            {row.status === 'incomplete' && inCompleteTools(row)}
            {row.status === 'completed' && completedTools(row)}
            {row.status === 'failed' && failedTools(row)}
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
  ];

  if (white_label_perkeso) columns.splice(9, 1); // REMOVES Campaign Cost

  const handleRowClicked = (row) => {
    handleModalDetailOpen({ status: row.status, campaignId: row.id, row: row });
  };

  const handleToggleOpen = (state, row) => {
    setIsActive(state);
    if (state) {
      setActiveRow(row.id);
    } else {
      setActiveRow(null);
    }
  }

  const conditionalRowStyles = [
    {
      when: (row) => isActive && activeRow && activeRow === row.id,
      style: {
        zIndex: '999 !important'
      }
    }
  ];

  return (
    <div>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <DataTable
        columns={columns}
        data={data}
        className="custom-datatable campaign-table"
        paginationComponentOptions={{
          rowsPerPageText: 'Items per page:',
        }}
        pagination
        onRowDoubleClicked={handleRowClicked}
        conditionalRowStyles={conditionalRowStyles}
      />
      <CampaignDetails
        modalDetailShow={modalDetailShow}
        setModalDetailShow={setModalDetailShow}
        campaignStatus={campaignStatus}
        campaignDetailsData={campaignDetailsData}
        resumeCampaign={resumeCampaign}
      />
      <Modal
        show={modalDeleteShow}
        className="modal-delete"
        animation={true}
        onHide={() => setModalDeleteShow(false)}
        centered
      >
        <Modal.Body>
          <CloseIcon handleModalClose={() => setModalDeleteShow(false)} />
          <RedIconSVG />
          <Modal.Title as="h4" style={{ margin: '16px 0 8px' }}>
            Delete “{campaignDetailsData.name}”
          </Modal.Title>
          Are you sure you want to delete this <strong>{campaignDetailsData.name}</strong>? This
          action cannot be undone.
          <div className="d-flex justify-content-end" style={{ marginTop: 24, gap: 50 }}>
            <Button
              variant="outline-secondary"
              onClick={() => setModalDeleteShow(false)}
              style={{ minWidth: 160 }}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => deleteCampaign(campaignDetailsData.id)}
              style={{ minWidth: 160 }}
            >
              Confirm
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <SmsDetailModal
        campaignId={campaignId}
        show={smsDetailShow}
        setCampaignId={setCampaignId}
        setSmsDetailShow={setSmsDetailShow}
        dateRange={dateRange}
      />
    </div>
  );
};

export default CampaignTables
